<script setup lang="ts">
import ChatListItem from "@/views/Home/components/ChatListItem.vue";
import { ref, computed, reactive, watch, onMounted, onBeforeMount } from "vue";
import {
  bindDialogue,
  chatStatus,
  initChat,
} from "@/views/Home/useData/module/chat";
import {
  dialogueStatus,
  dialogueList,
  setSessionId,
  nextDialoguePage,
} from "@/views/Home/useData/module/dialogue";
import { ElMessage } from "element-plus";
import { resetInputBar } from "@/components/Dialogues/useData/useInputBar";

// bindDialogue("dialogueStatus", dialogueStatus);
// bindDialogue("dialogueList", dialogueList);

const loadHistory = () => {
  console.log("load history");
  nextDialoguePage();
};

const sessionId = computed(() => {
  return dialogueStatus.sessionId;
});

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

// watch(
//   sessionId,
//   (nVal) => {
//     const curDialogue = dialogueList.find((dialogue) => {
//       const sid = (dialogue as any).session_id;
//       return sid === nVal;
//     });
//     console.log("watch sessionId ", sessionId);
//     console.log("curDialogue", curDialogue);
//     initChat(sessionId.value, curDialogue);
//
//     //重制对话框
//     resetInputBar();
//   },
//   {
//     immediate: true,
//   }
// );

const changeSession = (index: number) => {
  if (isReplying.value) {
    ElMessage.warning("当前对话正在进行中，请先结束当前对话");
    return;
  }

  const item = dialogueList[index] as any;

  if (item.session_id === sessionId.value) {
    return;
  }

  setSessionId(item.session_id);
};

const isSelectedDialogue = (index: number) => {
  const item = dialogueList[index] as any;
  return item.session_id === sessionId.value;
};
</script>

<template>
  <div class="history">
    <div class="list" v-infinite-scroll="loadHistory">
      <div>
        <ChatListItem
          v-for="(item, index) in dialogueList"
          :key="item.session_id"
          :sessionItem="item"
          :index="index"
          :isSelected="isSelectedDialogue(index)"
          @changeDialogue="changeSession(index)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.history {
  width: 100%;
  height: 100%;
  flex: 1;

  padding-top: 30px;
  padding-bottom: 10px;

  overflow: hidden;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    ::-webkit-scrollbar {
      margin-left: 5px !important;
      display: block !important;
      width: 4px !important;
      background-color: whie !important;
    }

    ::-webkit-scrollbar-thumb {
      height: 30px !important;
      background-color: #cccccc !important;
      border-radius: 10px !important;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
    }
  }

  .list::-webkit-scrollbar {
    width: 12px;
  }
  .list::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px;
  }
  .list::-webkit-scrollbar-thumb {
    background: #4d6bfe44;
    border-radius: 10px;
    border: 2px solid #f0f0f0;
  }
  .list::-webkit-scrollbar-thumb:hover {
    background: #4d6bfe44;
  }
}
</style>
